import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AgendaInstalacaoMarcada {
  origem: "entrada" | "reagendamento";
  quando: string;
  quem: string | null;
}

/** Quem marcou a data da instalação que vale hoje (o Inputar ou o último Reagendar). */
export function useAgendaInstalacaoMarcada(itemId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ["agenda-instalacao-marcada", itemId],
    enabled: !!itemId && enabled,
    staleTime: 30_000,
    queryFn: async (): Promise<AgendaInstalacaoMarcada | null> => {
      const { data, error } = await supabase
        .from("item_agenda_instalacao")
        .select("origem, created_at, usuario_id")
        .eq("item_id", itemId!)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      if (!data) return null;
      let quem: string | null = null;
      if (data.usuario_id) {
        const { data: usuario } = await supabase
          .from("usuarios")
          .select("nome")
          .eq("id", data.usuario_id)
          .maybeSingle();
        quem = usuario?.nome ?? null;
      }
      return { origem: data.origem as AgendaInstalacaoMarcada["origem"], quando: data.created_at, quem };
    },
  });
}
